import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './CapsicumPage.css';
import ambicaCapsicum from '../images/capsicum-ambica-img.png';

const varieties = [
//   {
//     name: 'DS-AMBIKA',
//     image: ambikaCapsicum,
//     description: [
//       'Dynasty Agriseeds DS-Ambika Capsicum Seeds',
//       'Blocky open field sweet pepper',
//       'Usage: Fresh market',
//       'Surface: Smooth',
//       'Shape: Blocky',
//       'Color: Medium green to red',
//       'Fruit weight: 180-250 gm',
//       'Production slot: Open field',
//       'Uniform fruit size with high yield potential',
//       'High fruit bearing capacity and long distance transport capacity',
//       'Recommended states: Andhra Pradesh, Bihar, Chhattisgarh, Gujarat, Haryana, Himachal Pradesh, Karnataka, Madhya Pradesh, Maharashtra, Punjab, Tamil Nadu, Telangana, Uttar Pradesh, Uttarakhand, West Bengal',
//     ],
//   },
  {
    name: 'AMBICA',
    image: ambicaCapsicum,
    description: [
      'Plant type: Medium tall and strong',
      'Fruit shape: Long blocky',
      'Fruit colour: Dark green to red',
      'Fruit length: 10-11 cm',
      'Fruit diameter: 7-8.5 cm',
      'Pericarp thickness: 5 mm',
      'Fruit weight: 140-150 gm',
      'First picking: 60-65 days',
      'Remark: Fresh green long blocky fruit suitable for long distance shipping',
    ],
  },
  
];

export default function CapsicumPage() {
  return <ProductPatternPage title="Capsicum" varieties={varieties} pageClass="capsicum-page" />;
}
